module.exports = __webpack_public_path__ + "img/preving-crm-logo.9c522a39.png";